import { ChangeDetectorRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HahaHttpService } from '../../../../core/haha/_services/haha-http.service';
import { coldBrewErrorMessage, coldBrewStatusLabel } from '../../../../core/haha/_utils/cold-brew-labels';
import { MachineRouteService } from '../machine-route.service';
// Read-only: shows the cold brew fridge paired with this machine. Pairing is managed from the fridge.
var MachineColdBrewComponent = /** @class */ (function () {
    function MachineColdBrewComponent(route, machineRouteService, hahaHttp, cdr) {
        this.route = route;
        this.machineRouteService = machineRouteService;
        this.hahaHttp = hahaHttp;
        this.cdr = cdr;
        this.machineName = '';
        this.result = null;
        this.isLoading = false;
        this.errorMessage = '';
        this.statusLabel = coldBrewStatusLabel;
    }
    MachineColdBrewComponent.prototype.ngOnInit = function () {
        var _this = this;
        var machine = this.machineRouteService.getMachine(this.route);
        if (!machine) {
            return;
        }
        this.machineName = String(machine.machine_name || machine.machine_id || '');
        this.isLoading = true;
        this.hahaHttp.getMachinePairedDevice(String(machine.machine_id || '')).subscribe({
            next: function (response) {
                _this.result = response && response.data ? response.data : null;
                _this.isLoading = false;
                _this.cdr.detectChanges();
            },
            error: function (error) {
                _this.errorMessage = coldBrewErrorMessage(error, 'Failed to load the paired cold brew fridge.');
                _this.isLoading = false;
                _this.cdr.detectChanges();
            }
        });
    };
    Object.defineProperty(MachineColdBrewComponent.prototype, "fridgeName", {
        get: function () {
            var device = this.result && this.result.device;
            return device ? device.name || device.haha_market_id : '';
        },
        enumerable: true,
        configurable: true
    });
    return MachineColdBrewComponent;
}());
export { MachineColdBrewComponent };
